import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { useEffect, useLayoutEffect, useState } from "react";

const useGetWorkforceDetailsByIdentifier = (identifier) => {
  const [workforceDetails, setWorkforceDetails] = useState({});
  const [workforceDetailsLoading, setWorkforceDetailsLoading] = useState(
    () => Boolean(identifier),
  );

  useLayoutEffect(() => {
    if (!identifier) {
      setWorkforceDetails({});
      setWorkforceDetailsLoading(false);
      return;
    }
    setWorkforceDetailsLoading(true);
  }, [identifier]);

  useEffect(() => {
    if (!identifier) return;

    const getWorkforceDetails = async () => {
      setWorkforceDetailsLoading(true);
      try {
        const payload = {
          userIdentifier: identifier,
        };
        const userData = await executeIntent(
          IntentType.GET_WORKFORCE_DETAILS_BY_USER_IDENTIFIER,
          payload,
        );
        setWorkforceDetails(userData?.[0] ?? {});
      } finally {
        setWorkforceDetailsLoading(false);
      }
    };

    getWorkforceDetails();
  }, [identifier]);

  return [workforceDetails, workforceDetailsLoading];
};

export default useGetWorkforceDetailsByIdentifier;
